<template>
  <section v-if="$slots.left || $slots.right" class="py-0">
    <div class="infoRow">
      <div class="row">
        <div class="infoRow__inner">
          <div v-if="$slots.left" class="infoRow__left">
            <slot name="left"></slot>
          </div>
          <div v-if="$slots.right" class="infoRow__right">
            <div><slot name="right"></slot></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
